<template>
  <div class="relative w-full">
    <span class="fak fa-search absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-bhav-blue-200" aria-hidden="true"></span>
    <input
      type="text"
      v-model="value"
      v-bind="$attrs"
      ref="searchInput"
      @keyup.enter="handleSearch"
      class="w-full rounded-lg pl-10 pr-10 py-3 text-sm leading-5 focus:outline-none transition-colors bg-bhav-cool-gray-50 text-bhav-blue-500 placeholder:text-bhav-blue-200"
    />
    <button
      v-if="value"
      type="button"
      @click.stop="clear"
      class="far fa-times absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer hover:opacity-70 transition-opacity text-bhav-blue-200"
      aria-label="Clear search"
    ></button>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
    'clear',
    'search'
  ],
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      debounceTimer: null
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.debounceSearch();
      }
    }
  },
  methods: {
    clear() {
      this.value = '';
      this.$emit('clear');
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    handleSearch() {
      this.$emit('search');
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
    },
    debounceSearch() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.$emit('search');
      }, 1000);
    }
  },
  beforeUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
}
</script>
